// Runtime environment accessor.
//
// Prefers values injected at container start via `window.__ENV__` (populated by
// /config.js, which the nginx image regenerates from the pod's VITE_* env vars),
// and falls back to build-time `import.meta.env` so the local Vite dev server / HMR
// keeps working. This lets a single built image serve every tenant/environment.
const runtime: Record<string, string | undefined> =
  (typeof window !== 'undefined' && window.__ENV__) || {};

const read = (key: string): string | undefined =>
  runtime[key] ?? (import.meta.env as Record<string, string | undefined>)[key];

export const ENV = {
  VITE_NODE_ENV: read('VITE_NODE_ENV'),
  VITE_AUTH_SERVER: read('VITE_AUTH_SERVER'),
  VITE_LABIQ_SERVER: read('VITE_LABIQ_SERVER'),
  VITE_COMMERCE_SERVER: read('VITE_COMMERCE_SERVER'),
  VITE_HEALTHCARE_SERVER: read('VITE_HEALTHCARE_SERVER'),
  VITE_FILE_SERVER: read('VITE_FILE_SERVER'),
  VITE_FINANCE_SERVER: read('VITE_FINANCE_SERVER'),
  VITE_FRONTEND_BASE_URL: read('VITE_FRONTEND_BASE_URL'),
  VITE_NOTIFICATION_BASE_URL: read('VITE_NOTIFICATION_BASE_URL'),
  // Same-origin paths after the gateway cutover (contract §19, §22): Reverb's wsPath and talk's Socket.IO path.
  VITE_NOTIFICATION_WS_PATH: read('VITE_NOTIFICATION_WS_PATH'),
  VITE_REVERB_APP_KEY: read('VITE_REVERB_APP_KEY'),
  VITE_TALK_SERVER: read('VITE_TALK_SERVER'),
  VITE_TALK_PATH: read('VITE_TALK_PATH'),
  // JSON array of RTCIceServer entries for the consult WebRTC mesh (see
  // src/utils/consult/iceServers.ts). Unset ⇒ the default Google STUN list; a TURN relay is added
  // later by setting this, with no code change.
  VITE_ICE_SERVERS: read('VITE_ICE_SERVERS'),
  VITE_APPOINTMENTS: read('VITE_APPOINTMENTS'),
  VITE_GENETIC_WHEEL: read('VITE_GENETIC_WHEEL'),
  VITE_NOTIFICATIONS_ENABLED: read('VITE_NOTIFICATIONS_ENABLED'),
  VITE_XOE_ENABLED: read('VITE_XOE_ENABLED'),
  VITE_XOE_AGENT_SERVER: read('VITE_XOE_AGENT_SERVER'),
  VITE_XOE_STREAMING_ENABLED: read('VITE_XOE_STREAMING_ENABLED'),
  VITE_RESEARCH_ENABLED: read('VITE_RESEARCH_ENABLED'),
} as const;
